import { QuizConfig } from '../../types/quiz';

const mentalHealthQuiz: QuizConfig = {
  id: 'mental-health',
  title: '정신건강 자가진단',
  shortTitle: '정신건강',
  description: '12가지 질문으로 나의 정신건강 상태를 확인해보세요',
  icon: '🌱',
  gradient: ['#E8F5E9', '#66BB6A'],
  headerColor: '#C8E6C9',
  questions: [
    { id: 1, description: '일상적인 활동에 흥미나 즐거움을 느낍니까?', yesScore: 4, noScore: -3 },
    { id: 2, description: '최근 2주간 우울하거나 절망적인 기분이 자주 들었습니까?', yesScore: -4, noScore: 3 },
    { id: 3, description: '하루를 시작할 충분한 에너지가 있습니까?', yesScore: 3, noScore: -3 },
    { id: 4, description: '자신에 대해 긍정적으로 생각합니까?', yesScore: 4, noScore: -3 },
    { id: 5, description: '감정의 기복이 심합니까?', yesScore: -3, noScore: 3 },
    { id: 6, description: '친구나 가족과 정기적으로 교류합니까?', yesScore: 3, noScore: -3 },
    { id: 7, description: '스트레스를 건강하게 해소하는 방법이 있습니까?', yesScore: 4, noScore: -2 },
    { id: 8, description: '미래에 대해 희망적으로 생각합니까?', yesScore: 3, noScore: -3 },
    { id: 9, description: '일이나 공부에 집중할 수 있습니까?', yesScore: 3, noScore: -3 },
    { id: 10, description: '식사와 수면이 규칙적입니까?', yesScore: 3, noScore: -3 },
    { id: 11, description: '어려운 상황에서도 대처할 수 있다고 느낍니까?', yesScore: 4, noScore: -2 },
    { id: 12, description: '최근 감정적으로 폭발하거나 과도하게 울은 적이 있습니까?', yesScore: -3, noScore: 3 },
  ],
  explanations: [
    { good: '일상에서 즐거움을 느끼는 것은 정신건강의 핵심 지표입니다!', bad: '무쾌감증은 우울증의 주요 증상입니다. 전문가 상담을 고려해보세요.' },
    { good: '정서적으로 안정된 상태를 유지하고 있어요!', bad: '2주 이상 지속되는 우울감은 전문적 도움이 필요할 수 있습니다.' },
    { good: '충분한 에너지는 건강한 정신 상태를 나타냅니다!', bad: '만성 무기력은 우울증이나 번아웃의 신호일 수 있습니다.' },
    { good: '건강한 자존감은 정신건강의 기초입니다!', bad: '부정적 자기 인식은 불안과 우울을 악화시킬 수 있습니다.' },
    { good: '안정적인 감정은 정서 조절 능력이 좋다는 뜻입니다!', bad: '감정 기복은 스트레스 과부하나 정서 조절 어려움을 나타냅니다.' },
    { good: '사회적 연결은 정신건강의 강력한 보호 요인입니다!', bad: '사회적 고립은 우울증과 불안장애 위험을 높입니다.' },
    { good: '건강한 스트레스 해소법이 있다면 회복탄력성이 높습니다!', bad: '스트레스 대처 능력 부족은 정신건강 문제로 이어질 수 있습니다.' },
    { good: '희망적 시각은 정신건강의 중요한 보호 요인입니다!', bad: '절망감이 지속되면 반드시 전문 상담을 받아주세요.' },
    { good: '집중력이 유지되고 있다면 인지 기능이 안정적입니다!', bad: '집중력 저하는 우울, 불안, ADHD 등 다양한 원인이 있을 수 있습니다.' },
    { good: '규칙적 생활은 정신건강 유지의 기본입니다!', bad: '불규칙한 생활 패턴은 정서 불안정을 유발합니다.' },
    { good: '자기효능감은 정신건강의 핵심 역량입니다!', bad: '무력감이 지속되면 학습된 무기력으로 이어질 수 있습니다.' },
    { good: '감정이 안정적으로 유지되고 있어요!', bad: '감정 조절의 어려움은 전문 상담이 도움이 될 수 있습니다.' },
  ],
  healthTips: [
    { question: '흥미/즐거움', tip: '하루에 하나라도 즐거운 활동을 계획해보세요. 작은 것이라도 좋습니다.', icon: '🎯' },
    { question: '우울감', tip: '정신건강 위기상담전화 1577-0199로 전화해보세요. 전문 상담이 큰 도움이 됩니다.', icon: '📞' },
    { question: '에너지', tip: '아침 햇빛 노출과 가벼운 스트레칭으로 하루를 시작해보세요.', icon: '🌅' },
    { question: '자존감', tip: '감사 일기를 써보세요. 하루 3가지 감사한 점을 적으면 자존감이 높아집니다.', icon: '📔' },
    { question: '감정 기복', tip: '감정을 숫자(1-10)로 기록해보세요. 패턴을 파악하면 조절이 쉬워집니다.', icon: '📊' },
    { question: '사회활동', tip: '주 1회라도 친구나 가족과 만남을 가져보세요. 화상 통화도 좋습니다.', icon: '👫' },
    { question: '스트레스 해소', tip: '운동, 명상, 그림 그리기, 음악 듣기 등 건강한 해소법을 찾아보세요.', icon: '🎨' },
    { question: '미래 희망', tip: '작은 목표를 세우고 달성해보세요. 성취 경험이 희망을 만듭니다.', icon: '⭐' },
    { question: '집중력', tip: '하루 10분 마음챙김 명상으로 집중력을 키울 수 있습니다.', icon: '🧘' },
    { question: '생활 규칙', tip: '매일 같은 시간에 자고 일어나고, 세 끼를 규칙적으로 먹어보세요.', icon: '📋' },
    { question: '자기효능감', tip: '과거에 어려움을 극복한 경험을 떠올려보세요. 당신은 할 수 있습니다.', icon: '💪' },
    { question: '감정 조절', tip: '감정이 격해질 때 STOP 기법을 사용하세요: 멈추고(S), 호흡하고(T), 관찰하고(O), 진행하기(P).', icon: '🛑' },
  ],
  categories: [
    { name: '정서 상태', color: '#66BB6A', indices: [0, 1, 4, 11] },
    { name: '에너지/활력', color: '#FF9800', indices: [2, 3] },
    { name: '사회적 기능', color: '#2196F3', indices: [5, 8] },
    { name: '대처/회복력', color: '#9C27B0', indices: [6, 7, 10, 11] },
    { name: '생활 관리', color: '#00BCD4', indices: [9] },
  ],
  resultTiers: [
    { maxScore: -12, title: '마음이 SOS 중', emoji: '🆘' },
    { maxScore: -4, title: '감정 롤러코스터', emoji: '🎢' },
    { maxScore: 6, title: '보통의 하루들', emoji: '🌤️' },
    { maxScore: 16, title: '마음의 여유 보유자', emoji: '🌈' },
    { maxScore: Infinity, title: '멘탈 갑부', emoji: '💎' },
  ],
  baseValue: 50,
  resultUnit: '점',
  resultPrefix: '정신건강 ',
  resultSuffix: '',
  percentile: { mean: 6, sd: 12 },
  seo: {
    title: '정신건강 자가진단 - 나의 정신건강은?',
    description: '12가지 질문으로 정신건강 상태를 자가진단해보세요. 정서, 사회적 기능, 대처 능력을 종합 평가합니다.',
  },
};

export default mentalHealthQuiz;
